import React from "react";

import "./style.css";

const PasswordIndicator = ({ count, t }) => {
  return (
    <div
      className="container"
      style={{
        display: "flex",
        gap: "10px",
        alignItems: "center",
      }}
    >
      <div className="indicator">
        <span className={count ? "fill" : "no-fill"}></span>
        <span className={count === 2 || count > 2 ? "fill" : "no-fill"}></span>
        <span className={count === 3 || count > 3 ? "fill" : "no-fill"}></span>
        <span className={count === 4 ? "fill" : "no-fill"}></span>
      </div>
      <div className={`indicator-text c${count}`}>
        {count === 4
          ? t("glossary:auth.reset-password.secure")
          : count === 3
          ? t("glossary:auth.reset-password.strong")
          : count === 2
          ? t("glossary:auth.reset-password.average")
          : t("glossary:auth.reset-password.weak")}
      </div>
    </div>
  );
};

export default PasswordIndicator;
